import { Box, styled } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  fieldsinarow?: number;
  sx?: object;
};

// aligns input fields in form.
export const InputsLayout = ({ children, fieldsinarow = 2, sx }: Props) => {
  return (
    <BoxStyled fieldsinarow={fieldsinarow} gap="8px" sx={sx}>
      {children}
    </BoxStyled>
  );
};

const BoxStyled = styled(Box)<{ fieldsinarow: number }>(({ fieldsinarow }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${fieldsinarow}, 1fr)`,
}));
